import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom"
import img1 from '../assets/images/ourstoryimg1.png'
import img2 from '../assets/images/ourstoryimg2.png';
import leaderImg1 from '../assets/images/brokers/Anne Young.webp';
import leaderImg2 from '../assets/images/brokers/Phil Soper.webp';
import leaderImg3 from '../assets/images/Yolevski-Karen-Feb-14-2023-headshot-WEB-06-e1704992414790-525x328.webp';
import leaderImg4 from '../assets/images/brokers/Melissa Salazar.webp';
import leaderImg5 from '../assets/images/John-O-Rourke-320xAUTO.fit_.webp';
import leaderImg6 from '../assets/images/Shelley-Reville-320xAUTO.fit_.jpg';
import leaderImg7 from '../assets/images/brokers/Philippe-Lecoq-768x768.webp';
import leaderImg8 from '../assets/images/brokers/Paul Weber.webp';
import leaderImg9 from '../assets/images/brokers/Grace Ng.webp';
import leaderImg10 from '../assets/images/brokers/Erin Billings.webp';
import leaderImg11 from '../assets/images/brokers/Keethan Selvarajah.webp';
import carousal1 from '../assets/images/carousal1.png'
import carousal2 from '../assets/images/carousal2.png'
import carousal3 from '../assets/images/carousal3.png'


import bgImg from '../assets/images/image-box-large-1-1-1.webp'
import getInTouchImg from '../assets/images/agent-1-1-1.webp';
import HeaderImg from "../assets/images/Header-Image-1.webp"
import HomeImage from "../assets/images/main-home-bg-img-1-1-1 (1).webp"
import { useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import '../App.css'
import Slider from 'react-slick';

const OurStory = () => {

    const fontStyle = {
        h3: {
            fontSize: "45px",
            fontFamily: '"Bodoni Moda", "Sans-serif"',
            color: "black",
            lineHeight: "1.5em",

        },
        h2: {
            color: " #FFFFFF",
            fontFamily: '"Bodoni Moda", "Sans-serif"',
            fontSize: "67px",
            fontWeight: " 400",
            lineHeight: "1.1em",
            textShadow: "0px 0px 10px rgba(0, 0, 0, 0.3)",
        },
        h4:{
            fontFamily: '"Bodoni Moda", "Sans-serif"',
            color: "black",
            lineHeight: "1.5em",
        }
    };
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        city: "",
        state: "",
        email: "",
        mobile: "",
        message: "",
        consent: false,
    });

    const [errors, setErrors] = useState({
        firstName: "",
        lastName: "",
        city: "",
        state: "",
        email: "",
        mobile: "",
        message: "",
        consent: "",
    });




    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const validateForm = () => {
        let formErrors = {};
        let isValid = true;

        // Name validation
        if (!formData.firstName) {
            formErrors.firstName = "First name is required";
            isValid = false;
        }
        if (!formData.lastName) {
            formErrors.lastName = "Last name is required";
            isValid = false;
        }

        // City and State validation
        if (!formData.city) {
            formErrors.city = "City is required";
            isValid = false;
        }
        if (!formData.state) {
            formErrors.state = "State is required";
            isValid = false;
        }

        // Email validation
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!formData.email) {
            formErrors.email = "Email is required";
            isValid = false;
        } else if (!emailPattern.test(formData.email)) {
            formErrors.email = "Please enter a valid email address";
            isValid = false;
        }

        // Mobile validation
        if (!formData.mobile) {
            formErrors.mobile = "Mobile number is required";
            isValid = false;
        } else if (formData.mobile.length !== 10) {
            formErrors.mobile = "Mobile number must be 10 digits";
            isValid = false;
        } else if (!/^\d{10}$/.test(formData.mobile)) {
            formErrors.mobile = "Mobile number must contain only digits";
            isValid = false;
        }

        // Message validation
        if (!formData.message) {
            formErrors.message = "Message is required";
            isValid = false;
        }

        // Consent validation
        if (!formData.consent) {
            formErrors.consent = "You must consent to the GDPR terms";
            isValid = false;
        }

        setErrors(formErrors);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate form
        if (validateForm()) {
            // Send form data or handle form submission here

            setFormData({
                firstName: "",
                lastName: "",
                city: "",
                state: "",
                email: "",
                mobile: "",
                message: "",
            })
        }

    };



    const members = [
        {
            name: "Anne Young", role: "VICE PRESIDENT, DIVISION MANAGER", phone: "246.380.7500", images: leaderImg1, id: 1, email: "AnneYoung.com", about: [
                "Anne Young is Vice President/Broker Manager at Royal LePage R.E.S. Ltd/Johnston and Daniel Ltd. Johnston & Daniel is known for its history of strong women in leadership, and Anne is no exception.",
                "With over 40 years of experience in GTA real estate and over 15 years with  Johnston & Daniel, Anne brings a wealth of knowledge and experience to her role.",
                "Anne is committed to the growth of her team. Her passion is to develop and empower REALTORS® to achieve their goals. She is aligned with the best real estate coaching companies in North America.  Having started her real estate career in an entry-level position, Anne knows the dedication and hard work it takes to succeed!",
                "As a member of the Johnston & Daniel leadership team, Anne strives for innovation, partnership, and collaboration. She is focused on bringing the Brokerage forward into future years ahead."
            ]
        },
        {
            name: "Phil Soper", role: "PRESIDENT & CEO, ROYAL LEPAGE", phone: "456.370.7500", images: leaderImg2, id: 2, email: "philsoper@royallepage.ca", about: [
                "Phil Soper is President and CEO of Royal LePage and Brookfield Real Estate Services, Inc. With over 18,000 agents in its Royal LePage, Royal LePage Commercial, Johnston & Daniel, and Via Capitale businesses is the largest real estate brokerage firm in Canada.",
                "The company has interests in the American market stemming from a series of acquisitions made from 2008 until 2012, including GMAC Real Estate, Real Living and Prudential Real Estate. In 2012, these businesses became Berkshire Hathaway HomeServices®, a joint-venture between Brookfield and Warren Buffet’s Berkshire Hathaway.",
                "A frequent commentator on economic issues and the North American real estate industry, Soper was honoured as, “CEO of the Year” by the Canadian Public Relations Society, a first for a real estate industry executive in the long history of the award.",
                "Soper’s community involvement includes United Way and Toronto SickKids Hospital campaign leadership, as well as directorships on the boards of the Royal LePage Shelter Foundation and Ryerson University’s Ted Rogers School of Business. He is a former governor of the University of Alberta."
            ]
        },
        {
            name: "Paul Weber", role: "Vice President of Operations & Development", phone: "416.489.2121", images: leaderImg8, id: 3, email: "melissas@royallepage.ca", about: [
                "With more than 30 years of experience in sales, operations, and team leadership, Paul brings a deep understanding of the real estate industry and a strong record of leadership. Most recently, Paul served as Senior Vice President at Phinney Real Estate, where he oversaw a team responsible for significant annual sales and played an instrumental role in rebranding and streamlining operations. His background also includes a senior role at Saks Fifth Avenue, where he led 13 departments and managed 120 associates, achieving substantial growth and developing company-wide training and coaching tools."
            ]
        },
        { name: "Philippe Lecoq", role: "President, Royal LePage® Real Estate Services Ltd.", phone: "416.489.2121", images: leaderImg7, id: 4, email: "KarenYolevski.com" },
        {
            name: "Melissa Salazar", role: "DIRECTOR MARKETING & CLIENT SOLUTIONS", phone: "416.489.2121", images: leaderImg4, id: 5, email: "MelissaSalazar.com", about: [
                "Melissa brings over 26 years in the real estate industry, and has celebrated 20 years with Royal LePage. For several years she has served in various real estate boards committees and organizations.  Her professional experience includes a successful career in several areas in the real estate industry such as team and agent consultant, team manager, and a senior director at a brokerage.",
                "In her current role she will be connecting with agents and teams to understand their needs and help them grow their business by providing strategic, creative and innovative solutions. Melissa has received the OREA YPN Leadership award in 2018, has been an Inman Global Ambassador since 2017 and forms part of the Buzz Conference Inner Circle. ",
                "Melissa is a high energy creative thinker, connector and tenacious social media networker. "
            ]
        },

        { name: "Grace Ng", role: "Controller, Finance", phone: "416.489.2121", images: leaderImg9, id: 6, email: "info@johnstonanddaniel.com" },
        // { name: "Erin Billings", role: "CHIEF OPERATING OFFICER, CORPORATE BROKERAGES", phone: "416.380.7500", images: leaderImg10, id: 3, email: "KarenYolevski.com" },
        { name: "Keethan Selvarajah", role: "Manager, Technology", phone: "416.489.2121", images: leaderImg11, id: 7, email: "kselvarajah@royallepage.ca" },
        { name: "John O'Rourke", role: "PRESIDENT, RUSHBROOKE REALTY", phone: "705.706.3425", images: leaderImg5, id: 8, email: "JohnO'Rourke.com" },
        { name: "Shelley Reville", role: "BROKER-OF-RECORD, RUSHBROOKE REALTY", phone: "705.765.6855", images: leaderImg6, id: 9, email: "ShelleyReville.com" },

        // { name: "Karen Yolevski", role: "CHIEF OPERATING OFFICER, CORPORATE BROKERAGES", phone: "416.380.7500", images: leaderImg3, id: 3, email: "KarenYolevski.com" },
    ];

    const franchiseMembers = [
        { name: "John O'Rourke", role: "PRESIDENT, RUSHBROOKE REALTY", phone: "705.706.3425", images: leaderImg5, id: 8, email: "JohnO'Rourke.com" },
        { name: "Shelley Reville", role: "BROKER-OF-RECORD, RUSHBROOKE REALTY", phone: "705.765.6855", images: leaderImg6, id: 9, email: "ShelleyReville.com" },
    ];


    const [allmember, setMember] = useState(members);
    const [franchise, setFranchise] = useState(franchiseMembers)

    // const results = [
    //     { value: "$100M", description: "Current Listing Volume" },
    //     { value: "$400M", description: "Total Sold 2020 - 2024" },
    //     { value: "$2B", description: "Lifetime Sales Volume" },
    // ];


    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.5 });
    const controls = useAnimation();

    useEffect(() => {
        if (inView) {
            controls.start({ opacity: 1, y: 0 });
        }
    }, [inView, controls]);

    const images = [carousal1, carousal2, carousal3]

    const sliderSettings = {
        // dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 800,
        fade: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        ltr: true,
    };
    return (
        <div className=' bg-gray-100'>
            <div className="relative h-[630px] mb-12 overflow-hidden">
                {/* Fixed text content */}
                <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center">
                    <h1 className="text-lg text-white">70 YEARS OF BESPOKE SERVICE BEHIND YOUR LISTING</h1>
                    <h3 style={fontStyle.h2} className="text-white">About Johnston & Daniel</h3>
                </div>

                {/* Image carousel with dark overlay */}
                <Slider {...sliderSettings}>
                    {images.map((img, index) => (
                        <div key={index}>
                            <div className="relative h-[630px] w-full">
                                {/* Background image */}
                                <div
                                    className="h-full w-full bg-cover bg-center"
                                    style={{ backgroundImage: `url(${img})` }}
                                ></div>

                                {/* Dark overlay */}
                                <div className="absolute inset-0 bg-black bg-opacity-50 z-10" />
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>



            <div className='' style={{ backgroundImage: `url(${HomeImage})` }}>
                <div className="flex flex-col md:flex-row items-center md:items-start min-h-screen bg-pink-50 px-28 pt-10 max-sm:px-5">
                    {/* Text Section */}
                    <div className="md:w-1/2 mt-10 p-10 pl-10 pr-12 text-start bg-white rounded-xl max-sm:p-0">
                        <h1 style={fontStyle.h3} className=" md:text-3xl ">
                            From breakaway idea to
                            global luxury property
                            nexus.
                        </h1>
                        <p className="mt-6 text-gray-600 leading-relaxed text-lg">
                            An awakening began in 1950. Post-war Toronto was finding its feet,
                            transforming from an undistinguished port of call into a powerhouse
                            of business, finance and manufacturing. This, and its many
                            geo-demographic advantages, attracted new wealth, investment and people.
                            And they all needed somewhere to live. A handful of seasoned real estate
                            professionals sensed this growing luxury niche was being underserved and
                            set out to disrupt the status quo with something much better.
                        </p>
                        <p className="mt-4 text-gray-600 leading-relaxed text-lg">
                            Johnston & Daniel: A vision bespoke. Our founders crafted an approach
                            that had never been tried in Toronto: To focus on fine homes and a
                            discriminating clientele, delivering superior results through a blend
                            of tailored service and “inside” advice. They also understood that
                            better service alone would not suffice.
                        </p>
                    </div>

                    {/* Image Section */}
                    <div className="md:w-1/2">
                        <img
                            src={img1} // Replace with the actual image path
                            alt="Luxury Kitchen"
                            className="w-full h-[700px] object-cover rounded-xl"
                        />
                    </div>
                </div>
            </div>
            <section style={{ backgroundImage: `url(${HomeImage})`, backgroundSize: 'contain' }}>
                <div className='mt-7 ' >
                    <div className="flex flex-col md:flex-row items-center md:items-start min-h-screen bg-pink-50 px-28 pt-10 max-sm:px-5">

                        {/* Image Section */}
                        <div className="md:w-1/2">
                            <img
                                src={img2} // Replace with the actual image path
                                alt="Luxury Kitchen"
                                className="w-full h-[700px] object-cover rounded-xl"
                            />
                        </div>
                        {/* Text Section */}
                        <div className="md:w-1/2 mt-10 p-10 text-start bg-white rounded-xl max-sm:p-0">
                            <h1 style={fontStyle.h3} className="leading-tight text-gray-800">
                                Relationships beyond the transactional.
                            </h1>
                            <p className="mt-6 text-gray-600 leading-relaxed text-lg">
                                J&D Realtors, they decided, must possess a sixth sense, a ground-state awareness of home sellers’ and buyers’ requirements and lifestyles – extending well beyond the deal. Anticipation over response. Professional-grade commitment over a hobbyist mentality. And above all, wisdom, diligence and integrity beyond reproach.
                            </p>
                            <p className="mt-4 text-gray-600 leading-relaxed text-lg">
                                New opportunities, ambitious women. So they hired and trained a team of shrewd local women (and a few good men) to become this new breed of Realtor – after all, women had always been the final arbiters in residential transactions. The idea caught fire. J&D Realtors excelled. Word-of-mouth did the rest.
                            </p>
                            <p className="mt-4 text-gray-600 leading-relaxed text-lg">
                                Two Canadian real estate titans unite. In 1994, Johnston & Daniel was acquired by Royal LePage, enabling increased dedication to service, more sophisticated marketing tools and a wider service offering. Today, J&D’s reach and influence connects our clients to real estate opportunities worldwide.
                            </p>
                        </div>


                    </div>
                </div>

            </section>

            <div className=''>
                <div className=' mb-10'>
                    <h1 style={fontStyle.h3} className=' p-5'>Leadership</h1>
                    <p className='text-gray-600 leading-relaxed text-lg px-96 max-sm:px-0'>Our leadership team collectively boasts decades of industry experience and is committed to enhancing the brokerage experience through professionalism, growth of our people and upholding the virtue that is the Standard Of Excellence®.</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 px-28 mt-4 max-sm:px-5 " >
                    {members
                        .filter(member => member.id !== 8 && member.id !== 9)
                        .map((member, index) => (
                            <div
                                key={index}
                                onClick={() => navigate(`/ourstory/${member.name}`, { state: { allmember } })}
                                className="relative bg-black text-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                            >
                                <div className="absolute inset-0 bg-black opacity-30"></div>

                                <div
                                    className="h-[27rem] bg-cover bg-center"
                                    style={{
                                        backgroundImage: `url('${member.images}')`,
                                    }}
                                ></div>
                                <div className="absolute bottom-4 left-4 text-start">
                                    <h3 className="text-lg font-bold">{member.name}</h3>
                                    <p className="text-sm">{member.role}</p>
                                </div>
                            </div>
                        ))}


                </div>

                <div className='mt-16 flex flex-col ' >
                    <h1 style={fontStyle.h4} className='mb-10 text-2xl'>J&D FRANCHISE</h1>
                    <div className="flex flex-col md:flex-row justify-center items-center gap-10" >
                        {franchise.map((member, index) => (
                            <div
                                key={index}
                                onClick={() => navigate(`/ourstory/${member.name}`, { state: { allmember } })}
                                className="relative bg-black text-white w-[320px]  md:w-[400px] h-full rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                            >
                                <div className="absolute inset-0 bg-black opacity-30"></div>

                                {/* Replace the background image below with actual image URLs */}
                                <div
                                    className="h-[27rem]  bg-cover bg-center"
                                    style={{
                                        backgroundImage: `url('${member.images}')`,
                                    }}
                                ></div>
                                <div className="absolute bottom-4 left-4 text-start">
                                    <h3 className="text-lg font-bold">{member.name}</h3>
                                    <p className="text-sm">{member.role}</p>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>

            </div>

            <div className='mt-32' ref={ref}>
                <div
                    className="relative bg-cover bg-center h-[500px] flex items-center max-sm:h-[800px]"
                    style={{
                        backgroundImage:
                            `url(${bgImg})`, // Replace with your image URL
                    }}
                >
                    <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                    <div className="relative text-center w-full">
                        <h2 style={fontStyle.h2} className="text-white   tracking-wide mb-12">
                            OUR RESULTS
                        </h2>
                        <div className="grid grid-cols-3 gap-20 items-start text-white max-sm:grid-cols-1">
                            <div className="text-center">
                                <motion.h2
                                    className="text-6xl font-bold text-gold-400"
                                    initial={{ opacity: 0, y: 50 }}
                                    animate={controls}
                                    style={{
                                        fontFamily: '"Bodoni Moda", "Sans-serif"',
                                        fontSize: "67px",
                                        fontWeight: " 400",
                                    }}
                                >
                                    ${inView && <CountUp start={0} end={100} duration={3.5} />}M
                                </motion.h2>
                                <p style={{ fontSize: "22px", fontWeight: "400px", fontFamily: '"Roboto Slab","Sans-serif"' }} className=" mt-2">Current Listing Volume</p>
                            </div>

                            <div className="text-center">
                                <motion.h2
                                    className="text-6xl font-bold text-gold-400"
                                    initial={{ opacity: 0, y: 50 }}
                                    animate={controls}
                                    style={{
                                        fontFamily: '"Bodoni Moda", "Sans-serif"',
                                        fontSize: "67px",
                                        fontWeight: " 400",
                                    }}
                                >
                                    ${inView && <CountUp start={300} end={400} duration={3.5} />}M
                                </motion.h2>
                                <p style={{ fontSize: "22px", fontWeight: "400px", fontFamily: '"Roboto Slab","Sans-serif"' }} className="text-lg mt-2">Total Sold 2020 - 2024</p>
                            </div>
                            <div className="text-center">
                                <motion.h2
                                    className="text-6xl font-bold text-gold-400"
                                    initial={{ opacity: 0, y: 50 }}
                                    animate={controls}
                                    style={{
                                        fontFamily: '"Bodoni Moda", "Sans-serif"',
                                        fontSize: "67px",
                                        fontWeight: " 400",
                                    }}
                                >
                                    ${inView && <CountUp start={0} end={2} duration={3.5} />}B
                                </motion.h2>
                                <p style={{ fontSize: "22px", fontWeight: "400px", fontFamily: '"Roboto Slab","Sans-serif"' }} className="text-lg mt-2">Lifetime Sales Volume</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='mt-7 mb-20 relative'>
                <div className="absolute -top-7 w-[70%] h-[902px] bg-Stone-100 flex right-0"></div>
                <div className="flex flex-col md:flex-row items-center md:items-start min-h-screen bg-pink-50 px-28 pt-10 max-sm:px-5">

                    {/* Image Section */}
                    <div className="md:w-1/2 z-10">
                        <img
                            src={getInTouchImg} // Replace with the actual image path
                            alt="Luxury Kitchen"
                            className="w-full h-[713px] object-cover rounded-xl mt-10"
                        />
                    </div>
                    {/* Text Section */}
                    <div className="md:w-1/2 mt-10 p-10 text-start bg-white rounded-xl z-10 max-sm:p-0">
                        <div className="bg-white p-8 rounded-lg w-full border  max-w-lg">
                            <h1 style={{ fontSize: "40px", fontFamily: "'Bodoni Moda','Sans-serif'", fontWeight: "400px", textTransform: "capitalize" }} className="text-gray-800 mb-6">
                                Get In Touch!
                            </h1>
                            <form className="space-y-4 bg-gray-100 p-5 rounded-lg border" onSubmit={handleSubmit}>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <input
                                            type="text"
                                            name="firstName"
                                            value={formData.firstName}
                                            onChange={handleChange}
                                            placeholder="Name *"
                                            // className="border border-gray-300 rounded-lg p-2 w-full"
                                            className={`flex w-[100%] border p-2 rounded-lg outline-none text-gray-700 focus:bg-gray-200 ${errors.firstName ? "border-Red-700" : ""
                                                }`}
                                        />
                                        {errors.firstName && (
                                            <p className="text-Red-700 text-sm">{errors.firstName} *</p>
                                        )}
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            name="lastName"
                                            value={formData.lastName}
                                            onChange={handleChange}
                                            placeholder="Last Name *"
                                            className={` w-[100%] border p-2 rounded-lg outline-none text-gray-700 focus:bg-gray-200 ${errors.lastName ? "border-Red-700" : ""
                                                }`}
                                        />
                                        {errors.lastName && (
                                            <p className="text-Red-700 text-sm">{errors.lastName} *</p>
                                        )}
                                    </div>
                                </div>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <input
                                            type="text"
                                            name="city"
                                            value={formData.city}
                                            onChange={handleChange}
                                            placeholder="City *"
                                            className={` w-[100%] border p-2 rounded-lg outline-none text-gray-700 focus:bg-gray-200 ${errors.city ? "border-Red-700" : ""
                                                }`}
                                        />
                                        {errors.city && (
                                            <p className="text-Red-700 text-sm">{errors.city} *</p>
                                        )}
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            name="state"
                                            value={formData.state}
                                            onChange={handleChange}
                                            placeholder="State *"
                                            className={` w-[100%] border p-2 rounded-lg outline-none text-gray-700 focus:bg-gray-200 ${errors.state ? "border-Red-700" : ""
                                                }`}
                                        />
                                        {errors.state && (
                                            <p className="text-Red-700 text-sm">{errors.state} *</p>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Email *"
                                        className={` w-[100%] border p-2 rounded-lg outline-none text-gray-700 focus:bg-gray-200 ${errors.email ? "border-Red-700" : ""
                                            }`}
                                    />
                                    {errors.email && (
                                        <p className="text-Red-700 text-sm">{errors.email} *</p>
                                    )}
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        name="mobile"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                        placeholder="Mobile *"
                                        className={` w-[100%] border p-2 rounded-lg outline-none text-gray-700 focus:bg-gray-200 ${errors.mobile ? "border-Red-700" : ""
                                            }`}
                                    />
                                    {errors.mobile && (
                                        <p className="text-Red-700 text-sm">{errors.mobile} *</p>
                                    )}
                                </div>
                                <div>
                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        placeholder="Type your message"
                                        rows={4}
                                        className={` w-[100%] border p-2 rounded-lg outline-none text-gray-700 focus:bg-gray-200 ${errors.message ? "border-Red-700" : ""
                                            }`}
                                    />
                                    {errors.message && (
                                        <p className="text-Red-700 text-sm">{errors.message} *</p>
                                    )}
                                </div>
                                <div className="  ">
                                    <div className='flex  items-center gap-2 '>
                                        <input
                                            type="checkbox"
                                            name="consent"
                                            checked={formData.consent}
                                            onChange={handleChange}
                                            className="w-4 h-4 text-start"
                                        />
                                        <label htmlFor="consent" className="text-sm text-gray-600">
                                            I consent to the GDPR Terms
                                        </label>
                                    </div>
                                    {errors.consent && (
                                        <p className="text-Red-700 text-sm">{errors.consent}*</p>
                                    )}
                                </div>
                                <button
                                    type="submit"
                                    className="w-full bg-Green-900 text-white font-semibold py-2 rounded-lg shadow-md hover:bg-[#b0905e] transition"
                                >
                                    Send Email
                                </button>
                            </form>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
};

export default OurStory;